// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Bt-z","tooltipWrapper":"Ct-z","icon":"Dt-z","tooltip":"Et-z","content":"Ft-z"};